import { CostCenter } from '@/modules/negotiation/entities/interfaces/costCenter';

export const costCenterInitialState: CostCenter = {
  name: '',
  isDefault: false,
  companyId: '',
};
